export default __webpack_public_path__ + "static/Qualters-f0227e0d531f25c1cc329397112ddac9.jpg";